// Loading country select from custom js.
//import 'countrySelect.js';

/* $("#country_selector").countrySelect({
    preferredCountries: ["in", "ca", "gb", "us"],
}); */